import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';


@Directive({
    selector: '[fileDrop]'
})
export class FileDropDirective {

    @Output() public onFileDrop: EventEmitter<FileList> = new EventEmitter<FileList>();

    @Input() public formFieldName = 'file';

    @Output('fileOver')
    get fileOver() {
        return this._fileOver.pipe(distinctUntilChanged());
    }

    protected _fileOver = new EventEmitter<boolean>();

    constructor() {}

    @HostListener('drop', ['$event'])
    public onDrop(event: any): void {
        this._preventAndStop(event);

        const transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        this._fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    }

    @HostListener('dragover', ['$event'])
    public onDragOver(event: any): void {
        this._preventAndStop(event);
        this._fileOver.emit(true);
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(event: any): any {
        this._preventAndStop(event);
        this._fileOver.emit(false);
    }

    protected _preventAndStop(event: any): any {
        event.preventDefault();
        event.stopPropagation();
    }

    protected _getTransfer(event: any): any {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }
}
